// Global Scripts
class LocalizationForm extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('button');
    const list = this.querySelector('ul');
    const input = this.querySelector('input[name="country_code"], input[name="language_code"]');

    if (!btn || !list || !input) return;

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      list.hidden = expanded;
    });

    this.querySelectorAll('a[data-value]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const form = this.querySelector('form');
        input.value = a.dataset.value;
        form && form.submit(); // triggers a reload in the selected market
      });
    });
  }
}
customElements.define('localization-form', LocalizationForm);

(() => {
  const form = document.querySelector('localization-form form') || document.querySelector('form[action*="/localization"]');
  const select = form?.querySelector('[name="country_code"]');
  if (!form || !select) return;

  select.addEventListener('change', () => {
    sessionStorage.setItem('taScrollY', String(window.scrollY));
    form.submit();
  });

  window.addEventListener('DOMContentLoaded', () => {
    const y = Number(sessionStorage.getItem('taScrollY') || 0);
    if (y > 0) {
      sessionStorage.removeItem('taScrollY');
      window.scrollTo(0, y + 500);
    }
  });
  
})();